import '../sass/citrus-address-map.scss';

const mapStyle = [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
];

(() => {
    const $citrusAddressMaps = document.querySelectorAll('.citrus-address-map');

    if (!$citrusAddressMaps) return;

    $citrusAddressMaps.forEach($citrusAddressMap => {
        const $mapInner = $citrusAddressMap.querySelector('.citrus-address-map__map-inner');

        const initMap = async () => {
            const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
            
            if (!$mapInner) return;

            const { lat, lng, markerIconId } = $mapInner?.dataset;

            if (!lat || !lng) return;

            const position = new google.maps.LatLng(lat, lng);

            const map = new google.maps.Map($mapInner, {
                center: position,
                zoom: 14,
                disableDefaultUI: true,
                zoomControl: true,
                mapId: $mapInner?.id,
            });

            if (markerIconId) {
                const markerIcon = document.querySelector(markerIconId);

                const content = document.createElement('div');

                content.className = 'citrus-address-map__map-marker';
                content.innerHTML = markerIcon.innerHTML;

                new AdvancedMarkerElement({
                    map,
                    position,
                    content
                });
            }
        };

        initMap();
    });
})();
